import React from "react";
import {Segment} from "semantic-ui-react";

interface IProperties {
    account: {
        name: string
        code: string
        type: string
    }
    selected: boolean
    onClick: (selected: boolean) => void
}

/**
 * Список, отображающий информацию о счете/карте клиента.
 */
export default class ListSelect extends React.Component<IProperties> {

    handleClick = () =>
    {
        this.props.onClick(!this.props.selected);
    };

    render()
    {
        return (
            <Segment onClick={this.handleClick} className={this.props.selected ? "selected" : "not-selected"}>
                <div className={"account-item-container"}>
                    <img src={process.env.PUBLIC_URL + "/icon/wallet.ico"} alt={"wallet ico"} />
                    <div>
                        <div><b>{this.props.account.name}</b></div>
                        <div className={"word-wrap"}>{this.props.account.code}</div>
                    </div>
                </div>
            </Segment>
        )
    }
}